"use strict";

/**
 * Parsbare Geometrie-Formate
 * @enum {string}
 */
gc.gis.format = {
	GEOJSON: 'geojson',
	WKT: 'wkt',
	OBJECT: 'object'
};

